
import { uploadFiles } from '../fileUploadService';

// Process file uploads with error handling
export const processFileUploads = async (
  files: File[] | undefined, 
  folderName: string,
  toastFn: any,
  maxFileSize: number = 5 * 1024 * 1024 // 5MB
): Promise<string[]> => {
  if (!files || !Array.isArray(files) || files.length === 0) {
    return [];
  }
  
  try {
    return await uploadFiles(files, folderName, maxFileSize);
  } catch (uploadError) {
    console.error(`Error uploading ${folderName}:`, uploadError);
    toastFn({
      title: 'เกิดข้อผิดพลาด',
      description: `ไม่สามารถอัปโหลดไฟล์ ${folderName === 'check-in-photos' ? 'รูปภาพเช็คอิน' : 'ใบงาน'} ได้
      ${uploadError}`,
      variant: 'destructive',
    });
    throw uploadError;
  }
};
